import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { getChildObject, getChildObjects, getFormRoot } from './form-data.utility';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';
import { combineLatest, forkJoin, of } from 'rxjs';
import { filter } from 'lodash';
import { FormControlStatus } from '@angular/forms';

export const setFormRecommendation = (destroyed$) => {
    return (field: FormlyFieldConfig) => {
        const root = getFormRoot(field);
        var fields = getChildObjects(root, 'intActionField') as FormlyFieldConfig[];
        var valueChangesArray = fields.map(
            f => f.formControl.valueChanges.pipe(startWith(null))
        );

        var valuesChanges$ = combineLatest(valueChangesArray);

        valuesChanges$.pipe(
            takeUntil(destroyed$)
        ).subscribe(
            {
                next: (v) => {
                    if(field.formControl.disabled){
                        field.formControl.enable();
                    }
                    var debugFields = fields.filter(f => f.props && f.props['valuesMatch'] === false && f.props['notLoaded'] === false);
                    if(fields.some(f => f.props && f.props['valuesMatch'] === false && f.props['notLoaded'] === false)){
                        field.formControl.setValue("The recommended action is 'Fail'");
                    } else {
                        field.formControl.setValue("The recommended action is 'Pass'");
                    }
                    if(!field.formControl.disabled){
                        field.formControl.disable();
                    }
                },
                error: (err) => console.log(err),
                complete: () => {}
            }
        )

    }
}